// ---------------------------------------------------------------------------
// V-ETA-2b. THE EVENT.CLINIC GRANT, HELD IN THIS TAB ONLY BETWEEN /enter AND THE CLAIM.
//
// The grant is the organiser's contact's personal access (CT-09). It never reaches
// Verbunk's server except in the one claim request, and it is held here, not in the URL,
// so a sign-in in between does not lose it and history never keeps it. sessionStorage is
// per tab and gone when the tab closes; every read removes it. A blocked storage simply
// means the link must be opened again after signing in.
// ---------------------------------------------------------------------------

export const HUB_GRANT_KEY = "verbunk.hubGrant";

/** Whether it was kept: the landing tells the requests screen when it was not. */
export function holdHubGrant(grant: string): boolean {
  try {
    sessionStorage.setItem(HUB_GRANT_KEY, grant);
    return true;
  } catch {
    // Private mode or blocked storage: nothing to keep.
    return false;
  }
}

/** Read once, and forget. */
export function takeHubGrant(): string | null {
  try {
    const grant = sessionStorage.getItem(HUB_GRANT_KEY);
    sessionStorage.removeItem(HUB_GRANT_KEY);
    return grant;
  } catch {
    return null;
  }
}

/** Whether a grant is waiting, without spending it: sign-in uses this to come back here. */
export function hubGrantWaiting(): boolean {
  try {
    return sessionStorage.getItem(HUB_GRANT_KEY) !== null;
  } catch {
    return false;
  }
}
